<template>
  <div class="hwid">
    <div>Информация об устройстве</div>
    <div><sub><strong>Fingerprint:</strong> {{ hwid }}</sub></div>
    <div><sub><strong>ОС и Браузер:</strong> {{ deviceName }}</sub></div>
  </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { UAParser } from 'ua-parser-js';

export default {
  data() {
    return {
      hwid: 'Загрузка...',
      deviceName: 'Загрузка...'
    }
  },
  async mounted() {
    // 1. Получаем виртуальный HWID
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.hwid = result.visitorId; // Уникальный хэш пользователя

    // 2. Получаем наименование устройства / ОС
    const parser = new UAParser();
    const os = parser.getOS();         // { name: "Windows", version: "10" }
    const browser = parser.getBrowser(); // { name: "Chrome", version: "..." }
    const device = parser.getDevice();   // Данные о модели (работает в основном на мобильных)

    if (device.vendor && device.model) {
      this.deviceName = `${device.vendor} ${device.model} (${os.name} ${os.version})`;
    } else {
      this.deviceName = `${os.name} ${os.version} / Браузер: ${browser.name}`;
    }
  }
}
</script>

<style scoped>
.hwid {
  color: var(--textColorDisabled);
}
</style>